import Vue from 'vue'
import Router from 'vue-router'
import util from '@/util.js'
import store from '../store'
import { cp_hidden_routers } from '@/const.js'
import { ActionType } from '../bean/UserAction'
import routerFilter from './router-filter'
/* Layout */
import Layout from '@/views/layout/Layout'
import MaterialLayout from '@/views/layout/material-layout'
import AppLayout from '@/components/app-layout/index.vue'
import managementLayout from '@/views/admin/layout/index'
/** note: sub-menu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    will control the page roles (you can set multiple roles)
    title: 'title'               the name show in sub-menu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if true, the page will no be cached(default is false)
    breadcrumb: false            if false, the item will hidden in breadcrumb(default is true)
    affix: true                  if true, the tag will affix in the tags-view
  }
 **/

Vue.use(Router)

// 获取原型对象上的push函数
// const originalPush = Router.prototype.push
// // 修改原型对象中的push方法
// Router.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }

export const constantRouterMap = [
  {
    path: '/',
    redirect: '/template/public',
    component: AppLayout,
    children: [
      {
        path: '/template/public',
        name: 'template-public',
        meta: {
          title: '模板广场',
          userActionKey: ActionType.publicTemplate.name.key
        },
        icon: 'el-icon-tickets',
        component: () => import('@/views/template/template-public-index.vue'),
        props: () => ({ scrollEl: '#app', publicProject: true })
      }
    ]
  },
  {
    path: '/',
    redirect: '/template',
    component: Layout,
    children: [
      {
        path: '/template',
        name: 'template',
        meta: {
          title: '模板库',
          userActionKey: ActionType.template.name.key
        },
        icon: 'el-icon-tickets',
        component: () => import('@/views/template/template-index.vue')
      }
    ]
  },
  {
    path: '/works/',
    component: AppLayout,
    meta: {
      title: '作品库'
    },
    children: [
      {
        path: 'my',
        name: 'my-works',
        meta: {
          title: '我的作品',
          userActionKey: ActionType.works.myWorksName.key
        },
        icon: 'el-icon-goods',
        component: () => import('@/views/works/works-index.vue'),
        props: () => ({ type: 'my' })
      },
      {
        path: 'team',
        name: 'my-team',
        meta: {
          title: '团队作品',
          userActionKey: ActionType.works.teamWorksName.key
        },
        icon: 'el-icon-goods',
        component: () => import('@/views/works/works-index.vue'),
        props: () => ({ type: 'team' })
      }
    ]
  },
  {
    path: '/material/',
    name: 'material',
    redirect: {
      name: 'material-img'
    },
    meta: {
      title: '素材库'
    },
    component: MaterialLayout,
    children: [
      {
        path: 'imgs',
        meta: {
          title: '图片素材',
          userActionKey: ActionType.material.imgName.key
        },
        name: 'material-img',
        component: () => import('@/views/material/material-index.vue'),
        props: () => ({ type: 'element' })
      },
      {
        path: 'bgImgs',
        meta: {
          title: '背景素材',
          userActionKey: ActionType.material.bgName.key
        },
        name: 'material-bg-img',
        component: () => import('@/views/material/material-bg-index.vue'),
        props: () => ({ type: 'bg' })
      },
      {
        path: 'bgColor',
        meta: {
          title: '背景颜色',
          userActionKey: ActionType.themeColor.name.key
        },
        name: 'material-bg-color',
        component: () => import('@/views/material/theme-color-index.vue'),
        props: () => ({ type: 'color' })
      }
    ]
  },
  {
    path: '/admin/dataView',
    component: Layout,
    children: [
      {
        path: '/',
        name: '数据统计',
        meta: {
          title: '数据统计',
          userActionKey: ActionType.dataView.name.key
        },
        component: () => import('@/views/admin/dataView/data-view-index.vue')
      }
    ]
  },
  {
    path: '/templateView/:id',
    component: Layout,
    children: [
      {
        path: '/',
        name: '模板统计',
        meta: {},
        component: () => import('@/views/admin/dataView/template-view.vue')
      }
    ]
  }
]
const templateEditor = {
  path: '/template/:id/editor',
  name: 'template-editor',
  meta: {
    title: '模板编辑',
    userActionKey: ActionType.editor.name.key
  },
  component: () => import('@/views/template/editor/template-editor-index.vue')
}
const templateFreeEditor = {
  path: '/templateFree/:id/editor',
  name: 'template-free-editor',
  meta: {
    title: '自由模板编辑',
    userActionKey: ActionType.templateFree.name.key
  },
  component: () => import('@/views/templateFree/template-free-index.vue')
}
// 改版的页面-自由模板
const tplFreeEditor = {
  path: '/tplFree/:id/editor',
  name: 'tpl-free-editor',
  meta: {
    title: '自由模板编辑',
    userActionKey: ActionType.templateFree.name.key
  },
  component: () => import('@/views/tpl-free/template-free-index.vue')
}
const workFreeEditor = {
  path: '/workFree/:id/editor',
  name: 'work-free-editor',
  meta: {
    title: '作品编辑',
    userActionKey: ActionType.templateFree.name.key
  },
  component: () => import('@/views/tpl-free/template-free-index.vue')
}
// const workFreeEditor = {
//   path: '/workFree/:id/editor',
//   name: 'work-free-editor',
//   meta: {
//     title: '作品编辑',
//     userActionKey: ActionType.templateFree.name.key
//   },
//   component: () => import('@/views/templateFree/template-free-index.vue')
// }
const templateEditorTrial = {
  path: '/template/:id/trial',
  name: 'template-editor',
  meta: {
    title: '编辑试用',
    isTrial: true,
    userActionKey: ActionType.editor.name.key
  },
  component: () => import('@/views/template/editor/user-trial-index.vue')
}
const templateGroupEditor = {
  path: '/templateGroup/:id/editor',
  name: 'template-group-editor',
  meta: {
    title: '图文模板编辑页',
    userActionKey: ActionType.templateGroup.editor.name.key
  },
  component: () => import('@/views/templateGroup/template-group-index.vue')
}
const workGroupEditor = {
  path: '/workGroup/:id/editor',
  name: 'works-group-editor',
  meta: {
    title: '图文作品编辑',
    userActionKey: ActionType.templateGroup.editor.name.key
  },
  component: () => import('@/views/templateGroup/template-group-index.vue')
}
const worksEditor = {
  path: '/works/:id/editor',
  name: 'works-editor',
  meta: {
    title: '作品编辑',
    userActionKey: ActionType.editor.name.key
  },
  component: () => import('@/views/template/editor/template-editor-index.vue')
}
const templateEditorTest = {
  path: '',
  component: Layout,
  children: [
    {
      path: '/psd',
      name: 'psdParse',
      title: '编辑',
      component: () =>
        import('@/views/template/editor/template-editor-test.vue')
    }
  ]
}
const imgPS = {
  path: '/img/ps',
  name: 'img-ps',
  meta: {
    title: '抠图',
    userActionKey: ActionType.ps.name.key
  },
  component: () => import('@/views/imgPS/img-ps-index.vue')
}
const aiDesign = {
  path: '/ai/design',
  name: 'ai-design',
  meta: {
    title: 'AI作图',
    userActionKey: ActionType.ai.name.key
  },
  component: () => import('@/views/ai-design/search.vue')
}
const psOnline = {
  path: '/ps/online',
  name: 'ps-online',
  meta: {
    title: 'PS在线'
    // userActionKey: ActionType.ps.name.key
  },
  component: () => import('@/views/ps-online/index.vue')
}
const payTips = {
  path: '/',
  component: Layout,
  children: [
    {
      path: '/pay/tips',
      name: '收费详情',
      meta: {
        title: '收费详情'
      },
      component: () => import('@/views/pay/tips.vue')
    }
  ]
}
const applyProject = {
  path: '/project/apply',
  name: 'project-apply',
  meta: {
    title: '项目申请',
    noAuth: true
  },
  component: () => import('@/views/project/project-apply-form.vue')
}
const otherPage = {
  path: '/',
  component: Layout,
  children: [
    {
      path: '/admin/userManagement',
      name: 'user-management',
      meta: {
        title: '成员管理',
        userActionKey: ActionType.userManagement.name.key
      },
      component: () => import('@/views/admin/user/user-management.vue')
    },
    {
      path: '/share/:id',
      name: 'share',
      meta: {
        title: '分享页',
        validationProjectId: true
      },
      component: () => import('@/views/share')
    }
  ]
}
const home = {
  path: '/home',
  name: 'home',
  title: '首页',
  meta: {
    noAuth: true,
    userActionKey: ActionType.home.name.key
  },
  component: () => import('@/views/home')
}
export const adminManagement = [
  {
    path: '/admin',
    name: '后台管理',
    redirect: '/admin/projectApproval',
    component: managementLayout,
    meta: {
      title: '管理员后台',
      noNews: true
    },
    children: [
      {
        path: '/admin/projectApproval',
        name: 'project-approval',
        meta: {
          title: '项目审批',
          role: ['SYS_ADMIN'],
          noNews: true
        },
        icon: 'el-icon-tickets',
        component: () =>
          import('@/views/admin/project/project-approval-table.vue')
      },
      {
        path: '/admin/projectManagement',
        name: 'project-management',
        meta: {
          title: '项目管理',
          role: ['SYS_ADMIN'],
          noNews: true
        },
        icon: 'el-icon-tickets',
        component: () => import('@/views/admin/project/project-mgt-table.vue')
      },
      {
        path: '/admin/newsManagement',
        name: 'news-management',
        meta: {
          title: '定投管理',
          role: ['SYS_ADMIN'],
          noNews: true
        },
        icon: 'el-icon-tickets',
        component: () => import('@/views/admin/news/news-table.vue')
      },
      {
        path: '/admin/projFont',
        name: 'admin-proj-font',
        meta: {
          title: '项目字体管理',
          role: ['SYS_ADMIN', 'PROJ_ADMIN'],
          noNews: true
        },
        icon: 'el-icon-tickets',
        component: () =>
          import('@/views/admin/fontFamily/font-project-index.vue')
      },
      {
        path: '/admin/sysFont',
        name: 'admin-sys-font',
        meta: {
          title: '公共字体管理',
          role: ['SYS_ADMIN'],
          noNews: true
        },
        component: () =>
          import('@/views/admin/fontFamily/font-system-index.vue')
      },
      {
        path: '/admin/template',
        name: 'admin-template-public',
        meta: {
          title: '公共模板库管理',
          role: ['SYS_ADMIN']
        },
        icon: 'el-icon-tickets',
        // redirect: {
        //   name: 'admin-template-public-list'
        // },
        // children: [{
        //   name: 'admin-template-public-list',
        //   component: () => import('@/views/admin/template/template-public-admin.vue')
        // }, {
        //   name: 'admin-template-public-tags',
        //   component: () => import('@/views/admin/template/template-public-admin.vue')
        // }],
        component: () =>
          import('@/views/admin/template/template-public-admin.vue')
      },
      {
        path: '/admin/material',
        name: 'admin-material',
        meta: {
          title: '公共素材库管理',
          role: ['SYS_ADMIN']
        },
        icon: 'el-icon-tickets',
        component: () => import('@/views/material/material-index.vue'),
        props: () => ({ type: 'element', publicProject: true })
      },
      {
        path: '/admin/bgImgs',
        meta: {
          title: '公共背景素材',
          role: ['SYS_ADMIN']
        },
        name: 'admin-bg-img',
        component: () => import('@/views/material/material-bg-index.vue'),
        props: () => ({ type: 'bg', publicProject: true })
      },
      {
        path: '/admin/templateManagement',
        name: 'template-management',
        meta: {
          title: '模板管理',
          role: ['SYS_ADMIN'],
          noNews: true
        },
        icon: 'el-icon-tickets',
        component: () => import('@/views/admin/template/template-mgt-table.vue')
        // children: [{
        //   name: 'template-management-list',
        //   component: () => import('@/views/admin/template/template-mgt-table.vue')
        // }, {
        //   name: 'template-management-list',
        //   component: () => import('@/views/admin/template/template-mgt-table.vue')
        // }]
      },
      {
        path: '/admin/preTemplate',
        name: 'admin-template-pre',
        meta: {
          title: '预置模板',
          role: ['SYS_ADMIN'],
          noNews: true
        },
        icon: 'el-icon-tickets',
        component: () => import('@/views/admin/template/template-pre-admin.vue')
      },
      {
        path: '/admin/userAction',
        name: 'user-action',
        meta: {
          title: '用户数据',
          role: ['SYS_ADMIN', 'PROJ_ADMIN']
        },
        icon: 'el-icon-tickets',
        component: () => import('@/views/admin/userAction/index.vue')
      },
      {
        path: '/admin/textMaterial',
        meta: {
          meta: {
            title: '文字素材',
            role: ['SYS_ADMIN']
          }
        },
        name: 'text-material',
        component: () => import('@/views/material/material-group-index.vue')
      },
      {
        path: '/admin/tagsManage',
        name: 'tags-manage',
        meta: {
          title: '作品管理',
          role: ['SYS_ADMIN', 'PROJ_ADMIN']
        },
        icon: 'el-icon-tickets',
        component: () => import('@/views/admin/tags/index.vue')
      }
    ]
  }
]
export const errorPage = [
  {
    path: '/*',
    name: '404',
    meta: {
      title: '404-页面没找到'
    },
    component: () => import('@/views/errorPage/404.vue')
  }
]
export const noAuthority = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/noProjectAuthority',
        name: 'no-project-authority',
        title: '无项目访问权限',
        component: () => import('@/views/errorPage/no-project-authority.vue')
      },
      {
        path: '/noPageAuthority',
        name: 'no-page-authority',
        title: '无页面访问权限',
        component: () => import('@/views/errorPage/no-page-authority.vue')
      }
    ]
  }
]
const cloudClass = {
  path: '/cloudClass/:jwt',
  name: 'cloudClass',
  title: '云课堂验证',
  meta: {
    userActionKey: ActionType.cloudClass.name.key
  },
  component: () => import('@/views/cloud/cloud-index')
}
const pageError = {
  path: '/error',
  name: 'error',
  title: '认证失败',
  component: () => import('@/views/errorPage/jwt-error.vue')
}
const test = {
  path: '/test',
  name: 'test',
  meta: {
    title: 'test'
  },
  component: () => import('@/views/test/index.vue')
}
const routers = [
  ...constantRouterMap,
  otherPage,
  templateEditor,
  templateGroupEditor,
  templateFreeEditor,
  tplFreeEditor,
  workFreeEditor,
  workGroupEditor,
  templateEditorTrial,
  worksEditor,
  templateEditorTest,
  applyProject,
  home,
  test,
  imgPS,
  aiDesign,
  psOnline,
  cloudClass,
  pageError,
  payTips,
  ...adminManagement,
  ...noAuthority,
  ...errorPage
]
export const router = new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: routers
})

const hasRouterPermission = (urlRole, loginUserInfo) => {
  return urlRole.indexOf(loginUserInfo.role) > -1
}
const hasProjectPermission = (urlProjectId, loginUserInfo) => {
  let hasProject = loginUserInfo.projectItems.some(item => {
    return item.id === urlProjectId
  })
  return hasProject
}
const hasPermissionForEditorPage = function (projectItems) {
  let hasPublicProject = projectItems.some(item => {
    return item.settings.SHOW_PUBLIC_PROJECT === 'ON'
  })
  return hasPublicProject
}
const validation = (to, from, next, loginUserInfo) => {
  let isEditorPages =
    [
      'template-editor',
      'template-free-editor',
      'template-group-editor',
      'tpl-free-editor'
    ].indexOf(to.name) > -1
  if (isEditorPages) {
    routerFilter.validatePublicTemplate(next, to)
    return
  }
  let urlRole = to.meta.role
  let validationProjectId = to.meta.validationProjectId
  let permissionRouter = urlRole && urlRole.length > 0
  let urlProjectId = to.query.projectId
  let templateEditable = []
  if (permissionRouter) {
    if (hasRouterPermission(urlRole, loginUserInfo)) {
      if (
        validationProjectId &&
        !hasProjectPermission(urlProjectId, loginUserInfo)
      ) {
        next({
          path: '/noProjectAuthority',
          replace: true,
          query: { ...from.query, from: to.path }
        })
        return
      } else {
        next()
        return
      }
    } else {
      next({
        path: '/noPageAuthority',
        replace: true,
        query: { from: to.path }
      })
      return
    }
  } else {
    if (
      validationProjectId &&
      !hasProjectPermission(urlProjectId, loginUserInfo)
    ) {
      next({
        path: '/noProjectAuthority',
        replace: true,
        query: { ...from.query, from: to.path }
      })
      return
    } else {
      next()
      return
    }
  }
}
const noAuthForStudyCP = function (routerName) {
  let isStudyCP = store.getters['app/isStudyCP']
  if (isStudyCP && cp_hidden_routers.indexOf(routerName) > -1) {
    return true
  } else {
    return false
  }
}
const noAuthPage = function (routerName) {
  let teamWorkVisible = store.getters['app/teamWorkVisible']
  if (['my-team'].indexOf(routerName) > -1 && !teamWorkVisible) {
    return true
  } else {
    return false
  }
}
const loginAfterRouter = function (to, from, next, loginUserInfo) {
  sessionStorage.removeItem('home')
  // if (
  //   to.name === 'template-public' &&
  //   !store.getters['app/publicResourceVisible']
  // ) {
  //   next({ path: '/template' })
  //   return
  // }
  if (to.meta.isTrial === true) {
    next()
  } else if (noAuthPage(to.name)) {
    next({ path: '/404' })
  } else if (noAuthForStudyCP(to.name)) {
    next({ path: '/404' })
  } else if (
    loginUserInfo.projectItems &&
    loginUserInfo.projectItems.length > 0
  ) {
    validation(to, from, next, loginUserInfo)
  } else if (
    loginUserInfo.projectApplyList &&
    loginUserInfo.projectApplyList.length === 0
  ) {
    to.meta.noAuth ? next() : next({ path: '/home' })
  } else {
    to.meta.noAuth ? next() : next({ path: '/project/apply' })
  }
}
const no_login_names = ['cloudClass', 'home']
router.beforeEach((to, from, next) => {
  if (to.name === 'home') {
    util.fullPath = '/'
  } else {
    util.fullPath = to.fullPath
  }
  let title = to.meta.title || '自助制图系统'
  document.title = title
  if (no_login_names.indexOf(to.name) > -1) {
    next()
    return
  }
  let loginUserInfo = store.state.app.loginUser
  let login = !!loginUserInfo.id
  if (
    to.name === 'home' &&
    (from.name !== null || sessionStorage.getItem('home'))
  ) {
    if (from.name !== null) {
      sessionStorage.setItem('home', true)
    }
    next()
  } else if (login) {
    loginAfterRouter(to, from, next, loginUserInfo)
  } else {
    store.dispatch('app/queryLoginUserInfo', to.query.projectId).then(data => {
      loginAfterRouter(to, from, next, data)
    })
  }
})
router.afterEach(to => {
  //设置云课堂url
  let yktUrl = util.getYKTCache()
  let query = { ...to.query }
  if (yktUrl) {
    query.errorUrl = yktUrl
  }
  router.replace({ path: to.path, query: query })
})
